module.exports = __webpack_public_path__ + "img/ltkhome-1x.c8a269d.jpg";